import { GetDateRangeModels, typeGetDateRangeType, GetDateRangeType } from './../../../models/date-range/get-date-range.models';

export function getDateRange(rangeCode: typeGetDateRangeType, today: Date): GetDateRangeModels {
    let dateRange = {
        fromDate: new Date(),
        toDate: new Date()
    }

    let todayCopy = new Date(today);

    switch (rangeCode) {
        case GetDateRangeType.today:
            dateRange.fromDate = today;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.yesterday:
            let yesterday = todayCopy;
            yesterday.setDate(todayCopy.getDate() - 1);

            dateRange.fromDate = yesterday;
            dateRange.toDate = yesterday;
            break;
        case GetDateRangeType.thisMonth:
            let firstday = todayCopy;
            firstday.setDate(1);

            dateRange.fromDate = firstday;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.lastMonth:
            dateRange.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            dateRange.toDate = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        case GetDateRangeType.last7Days:
            let seven = todayCopy;
            seven.setDate(todayCopy.getDate() - 7);

            dateRange.fromDate = seven;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.last15Days:
            let fifteen = todayCopy;
            fifteen.setDate(todayCopy.getDate() - 15);

            dateRange.fromDate = fifteen;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.last30Days:
            let thirty = todayCopy;
            thirty.setDate(todayCopy.getDate() - 30);

            dateRange.fromDate = thirty;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.last60Days:
            let sixty = todayCopy;
            sixty.setDate(todayCopy.getDate() - 60);

            dateRange.fromDate = sixty;
            dateRange.toDate = today;
            break;
        case GetDateRangeType.last90Days:
            let ninety = todayCopy;
            ninety.setDate(todayCopy.getDate() - 90);

            dateRange.fromDate = ninety;
            dateRange.toDate = today;
            break;
        default:
            break;
    }

    return dateRange;
}
